module.exports = __webpack_public_path__ + "static/media/rotorSemFundo.1a90e28e.png";